import React, { useState } from 'react';
import {
  TextField,
  Button,
  Typography,
  Paper,
 // Box,
  Stack,
} from '@mui/material';
import axios from 'axios';

const VerifySection = ({ showSnackbar }) => {
  const [code, setCode] = useState('');
  const [verifying, setVerifying] = useState(false);

  const verifyCode = async () => {
    setVerifying(true);
    try {
      await axios.post('/api/v1/google-merchant/merchant-auth-verify', { code });
      showSnackbar('✅ Verification successful');
      setCode('');
    } catch {
      showSnackbar('❌ Verification failed', 'error');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <Paper elevation={1} sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Typography variant="h6" fontWeight="bold">
          Step 2: Verify Authorization Code
        </Typography>

        <Typography variant="body2" color="text.secondary">
          After authorizing with Google, paste the returned code here to complete the connection.
        </Typography>

        <TextField
          fullWidth
          label="Paste Auth Code"
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="Enter the code from Google"
        />

        <Button
          variant="contained"
          color="success"
          onClick={verifyCode}
          disabled={!code || verifying}
        >
          {verifying ? 'Verifying...' : 'Verify Code'}
        </Button>
      </Stack>
    </Paper>
  );
};

export default VerifySection;
